import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import LayoutContextProvider, {
  LayoutElementState,
} from '../context/LayoutContext';

const useStyles = makeStyles()(() => ({
  root: {
    height: '100vh',
    display: 'grid',
    gridTemplateRows: 'minmax(0, max-content) auto',
  },
}));

/**
 * @description A layout component that should be the ancestor of all other components in the layout.
 */
export default function Container({
  children,
  className,
  defaultRightRailVisibility,
}: {
  children: React.ReactNode;
  className?: string;
  defaultRightRailVisibility?: LayoutElementState;
}) {
  const { classes, cx } = useStyles();

  return (
    <LayoutContextProvider
      defaultRightRailVisibility={defaultRightRailVisibility}
    >
      <Box className={cx(classes.root, className)}>{children}</Box>
    </LayoutContextProvider>
  );
}
